export default "__VITE_ASSET__CshKcn_h__"